/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-08-04 10:58:09
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-25 15:25:15
 */
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Popover,
  Row,
  Select,
} from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import React, { useEffect, useState } from 'react'
import { unwrapResult } from '@reduxjs/toolkit'
import moment from 'moment'
import { DateTimeFormatSimple, DateTimeFormat } from '../../../models/datetime'
import { getUserList } from '../../user/userSlice'
import { getEAFUseDetailAsync, getEAFUseSubmitAsync } from './EAFUseSlice'
import { getEAFRegisterListAsync } from '../EAFRegister/EAFRegisterSlice'
import styles from './EAFUse.module.css'
import { selectTenantId } from '../../../app/applicationSlice'

const { Option } = Select

export const AddOrEditFormModal = (props: {
  editTenantId?: any
  isEdit?: any
  id?: any
  isModalVisible: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const tenantId = useSelector(selectTenantId)

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [userList, setUserList] = useState<any>()

  const [deviceNumberData, setDeviceNumberData] = useState<any>()

  const [detail, setDetail] = useState<any>()

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 15 },
  }

  const getDetail = () => {
    dispatch(
      getEAFUseDetailAsync({
        id: props?.id,
        tenantId: props?.editTenantId,
      })
    )
      .then(unwrapResult)
      .then((v: any) => {
        setDetail(v)

        form.setFieldsValue({
          ...v,
          startTime: v?.startTime ? moment(v?.startTime) : '',
          stopTime: v?.stopTime ? moment(v?.stopTime) : '',
          operatorId: undefined,
          deviceId: undefined,
          deviceName: '',
          model: '',
        })
        dispatch(
          getEAFRegisterListAsync({
            current: 1,
            size: 100000,
            tenantId: tenantId,
          })
        )
          .then(unwrapResult)
          .then((res: any) => {
            setDeviceNumberData(res.records)

            const deviceId = res.records?.find(
              (val: any) => val?.id == v?.deviceId
            )

            form.setFieldsValue({
              deviceId: deviceId != undefined ? v?.deviceId : '',
              deviceName: deviceId != undefined ? v?.deviceName : undefined,
              model: deviceId != undefined ? v?.model : '',
            })
          })

        dispatch(getUserList({ current: 1, size: 1000, state: 1 }))
          .then(unwrapResult)
          .then((res: any) => {
            setUserList(res?.items)

            const operatorId = res.items?.find(
              (val: any) => val?.id == v?.operatorId
            )

            form.setFieldsValue({
              operatorId:
                operatorId != undefined ? v?.operatorId?.toString() : undefined,
            })
          })
      })
  }

  useEffect(() => {
    if (props.isModalVisible) {
      if (props?.id) {
        getDetail()
      } else {
        getEAFRegisterList()
        getUserData()
      }
    } else {
      form.resetFields()
      setDeviceNumberData([])
      setUserList([])
    }
  }, [props.isModalVisible, props?.id])

  const getUserData = () => {
    dispatch(getUserList({ current: 1, size: 1000, state: 1 }))
      .then(unwrapResult)
      .then((res: any) => {
        setUserList(res?.items)
      })
  }

  const getEAFRegisterList = () => {
    dispatch(
      getEAFRegisterListAsync({ current: 1, size: 100000, tenantId: tenantId })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setDeviceNumberData(res.records)
      })
  }

  return (
    <>
      <Modal
        width={1200}
        title={
          props?.isEdit == '0'
            ? '查看详情'
            : props?.id
            ? '编辑数据'
            : '添加数据'
        }
        visible={props.isModalVisible}
        footer={null}
        maskClosable={false}
        destroyOnClose={false}
        className={styles.modal}
        onCancel={() => {
          props.onCancel()
        }}
        onOk={() => {
          props?.onOk()
        }}
      >
        <Form
          autoComplete='off'
          form={form}
          onFinish={(vs) => {
            setConfirmLoading(true)
            const operatorName = userList?.find(
              (v: any) => v?.id == vs?.operatorId
            )?.name

            const deviceNumber = deviceNumberData?.find(
              (v: any) => v?.id == vs?.deviceId
            )?.deviceNumber

            const startTime = vs?.startTime
              ? moment(vs?.startTime)?.format(DateTimeFormat)
              : ''

            const stopTime = vs?.stopTime
              ? moment(vs?.stopTime)?.format(DateTimeFormat)
              : ''

            const params = props?.id
              ? {
                  ...vs,
                  id: detail?.id,
                  operator: operatorName,
                  startTime: startTime,
                  stopTime: stopTime,
                  deviceNumber: deviceNumber,
                }
              : {
                  ...vs,
                  operator: operatorName,
                  startTime: startTime,
                  stopTime: stopTime,
                  deviceNumber: deviceNumber,
                }
            dispatch(getEAFUseSubmitAsync({ ...params }))
              .then(unwrapResult)
              .then((v: any) => {
                notification.success({
                  message: '操作成功',
                })
              })
              .finally(() => {
                props?.onOk()
                setConfirmLoading(false)
              })
          }}
        >
          <Row>
            <Col span={8}>
              <Form.Item
                {...layout}
                label='设备编号'
                name='deviceId'
                rules={[
                  {
                    required: true,
                    message: '设备编号不能为空',
                  },
                ]}
              >
                <Select
                  dropdownClassName={styles.select}
                  placeholder='设备编号'
                  allowClear
                  onChange={(v) => {
                    const selectData = deviceNumberData?.find(
                      (val: any) => val?.id == v
                    )
                    form.setFieldsValue({
                      deviceId: selectData?.id,
                      deviceName: selectData?.deviceName,
                      model: selectData?.model,
                    })
                  }}
                >
                  {deviceNumberData?.map((v: any, index: any) => {
                    return (
                      <Option value={v?.id} key={index}>
                        {v?.deviceNumber}
                        {v?.deviceNumber ? '/' : ''}
                        {v?.deviceName}
                        {v?.deviceName ? '/' : ''}
                        {v?.model}
                        {v?.model ? '/' : ''}
                        {v.purchaseDate
                          ? moment(v?.purchaseDate).format(DateTimeFormatSimple)
                          : '-'}
                      </Option>
                    )
                  })}
                </Select>
                {/* <Input placeholder='设备编号' /> */}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                {...layout}
                label='设备名称'
                name='deviceName'
                rules={[
                  {
                    required: true,
                    message: '设备名称不能为空',
                  },
                ]}
              >
                <Input placeholder='设备名称' disabled />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='规格型号' name='model'>
                <Input placeholder='规格型号' disabled />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='设备状况' name='deviceStatus'>
                <Input placeholder='设备状况' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='启用时间' name='startTime'>
                <DatePicker
                  style={{ width: '100%' }}
                  placeholder='启用时间'
                  showTime
                  format={DateTimeFormat}
                  onChange={() => {
                    return
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='停止时间' name='stopTime'>
                <DatePicker
                  style={{ width: '100%' }}
                  placeholder='停止时间'
                  showTime
                  format={DateTimeFormat}
                  onChange={() => {
                    return
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='运转情况' name='runningStatus'>
                <Input placeholder='运转情况' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='使用地点' name='useLocal'>
                <Input placeholder='使用地点' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='使用目的' name='usePurpose'>
                <Input placeholder='使用目的' />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item {...layout} label='操作人' name='operatorId'>
                <Select placeholder='操作人' allowClear>
                  {userList?.map((v: any, i: any) => {
                    return (
                      <Option value={v?.id} key={i}>
                        {v?.name}
                      </Option>
                    )
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='备注' name='remark'>
                <Input placeholder='备注' />
              </Form.Item>
            </Col>
          </Row>
          {props?.isEdit == '0' ? (
            <></>
          ) : (
            <Row
              style={{
                marginTop: '20px',
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <Button
                loading={confirmLoading}
                type='primary'
                onClick={() => {
                  form.submit()
                }}
                style={{ marginRight: '10px' }}
              >
                确定
              </Button>
              <Button
                type='primary'
                ghost
                style={{ marginRight: '10px' }}
                onClick={() => {
                  props?.onCancel()
                }}
              >
                取消
              </Button>
            </Row>
          )}
        </Form>
      </Modal>
    </>
  )
}
